/* eslint-disable react/prop-types */
import { useState } from "react";

import {
  allDeviceTypeOption,
  colors,
  deviceGroupNames,
  deviceKitNameType,
  strCode
} from "../../../consts";
import { t } from "../../../services";
import { dateUtil, deviceUtil } from "../../../utils";

import { DeviceInfo, GradientLoader, TextOverflowWrapper } from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";
import { selectDeviceKitList } from "../../../state/selectors";
import { getState } from "../../../state/store";

const deviceFilter = (rows, id, filterValue) => {
  return rows.filter((row) => {
    const record = row.original;

    const deviceKit = record.isMercuryDevice
      ? record.device_model
      : deviceKitNameType[record.deviceModel];

    const typeName = record?.type?.toLowerCase().replace("_", "-");
    const type = ["holder-control", "holder-engine"].includes(typeName)
      ? deviceGroupNames.holder
      : ["device-control", "device-engine"].includes(typeName)
      ? deviceGroupNames.mono
      : typeName;

    const groups = record?.groups ?? [];

    return (
      (!filterValue.model ||
        filterValue.model.length === 0 ||
        filterValue.model.includes(deviceKit)) &&
      (!filterValue.type ||
        filterValue.type === allDeviceTypeOption.id ||
        type === filterValue.type) &&
      (!filterValue.groups ||
        filterValue.groups.length === 0 ||
        filterValue.groups.some((id) => groups.includes(id)))
    );
  });
};

export const DeviceTableColumns = [
  {
    Header: strCode.DEVICE_TITLE,
    accessor: "deviceName",
    filter: deviceFilter,
    Cell: ({ cell, cellWidth5, isLoading }) => {
      const [isImageLoaded, setIsImageLoaded] = useState(false);
      const [deviceImage, setDeviceImage] = useState();

      const record = cell?.row?.original;
      const isMercuryDevice = record?.isMercuryDevice;

      deviceUtil.getDeviceImageAsset(record?.deviceImage, isMercuryDevice).then((res) => {
        setDeviceImage(res);
      });

      return (
        <CellWrapper width={`${cellWidth5}px`}>
          <DeviceInfo
            isLoading={isLoading}
            isImageLoaded={isImageLoaded}
            imageSrc={deviceImage}
            setIsImageLoaded={setIsImageLoaded}
            model={cell.value}
            type={record.type}
            width={cellWidth5}
          />
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.SERIAL_NUMBER_TITLE,
    accessor: "dusn",
    Cell: ({ cell, cellWidth5, isLoading, searchedText }) => {
      return (
        <CellWrapper width={`${cellWidth5}px`}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }} highlightedText={searchedText}>
            {isLoading ? (
              <GradientLoader width={cellWidth5} height={24} animationDuration={40} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.CODENTIFY_TITLE,
    accessor: "codentify",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }}>
            {isLoading ? (
              <GradientLoader width={cellWidth8} height={24} animationDuration={40} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.KIT_CODENTIFY_TITLE,
    accessor: "kit-codentify",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      const record = cell?.row?.original;
      const codentify = record.codentify;

      const deviceKitList = selectDeviceKitList()(getState());
      const kitCodentify = deviceKitList?.find(
        (el) => el?.deviceCodentify === codentify
      )?.deviceKitCodentify;

      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }}>
            {isLoading ? (
              <GradientLoader width={cellWidth8} height={24} animationDuration={40} />
            ) : (
              kitCodentify
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.FIRMWARE_VERSION_TITLE,
    accessor: "latest_firmware_version",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper width={`fit-content`} minWidth={"145px"}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }}>
            {isLoading ? (
              <GradientLoader width={145} height={24} animationDuration={40} />
            ) : (
              cell.value ?? t(strCode.EMPTY_CELL_INFO)
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.FIRMWARE_UPDATED_TITLE,
    accessor: "latest_firmware_version_update_datetime",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      const date = cell?.value ? dateUtil.getUTCDate(new Date(cell?.value)) : null;
      const timestamp = date ? date?.getTime() : null;

      return (
        <CellWrapper width={`${cellWidth8}px`} minWidth={"155px"}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }}>
            {isLoading ? (
              <GradientLoader width={cellWidth8} height={24} animationDuration={32} />
            ) : timestamp ? (
              dateUtil.formatDateFromTimestamp(timestamp)
            ) : (
              t(strCode.EMPTY_CELL_INFO)
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  }
];
